import { Controller } from "@hotwired/stimulus";
import stimulusHelpers from "../../lib/stimulus_helpers";

export default class extends Controller {
  storedMassSelectionController = null;

  connect() {
    this.element.addEventListener("turbo:submit-end", this.afterSubmitEvent);
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.afterSubmitEvent);
  }

  afterSubmitEvent = (event) => {
    if (event.detail.success === true) {
      stimulusHelpers.getController("mass-selection").deselectAll();
      stimulusHelpers.getController("puts--dialog").close();
    }
  };
}
